<template>
    <!--  TODO  napojit promennou horizontal  -->
    <div class="CategoryFilter ProductCategory-filter" :class="{'CategoryFilter--horizontal': horizontal, 'is-open': isOpenedFilterModal}">
        <div class="CategoryFilter-panel">
            <SpinnerGlobal v-if="isLoading"/>
            <h2 v-if="!horizontal" class="CategoryFilter">{{ filterTitle }}</h2>
            <FilterSection v-for="filterSection in filter.sections"
                           :key="filterSection.name"
                           :section="filterSection"/>
            <div v-if="isAppliedFilter" class="CategoryFilter-resetContainer">
                <button @click="clearFilter(null)" class="CategoryFilter-reset" type="button">
                    <svg width="16" height="16" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 320 512">
                        <path fill="currentColor" d="M207.6 256l107.72-107.72c6.23-6.23 6.23-16.34 0-22.58l-25.03-25.03c-6.23-6.23-16.34-6.23-22.58 0L160 208.4 52.28 100.68c-6.23-6.23-16.34-6.23-22.58 0L4.68 125.7c-6.23 6.23-6.23 16.34 0 22.58L112.4 256 4.68 363.72c-6.23 6.23-6.23 16.34 0 22.58l25.03 25.03c6.23 6.23 16.34 6.23 22.58 0L160 303.6l107.72 107.72c6.23 6.23 16.34 6.23 22.58 0l25.03-25.03c6.23-6.23 6.23-16.34 0-22.58L207.6 256z"></path>
                    </svg>
                    <span>{{ cancelLabel }}</span>
                </button>
            </div>
        </div>
        <div :class="{'CategoryFilter-controls': true, 'is-applied-filter': isAppliedFilter}">
            <ButtonCloseFilter :text="applyOrCloseFilterLabel" @click="closeFilterModal"/>
        </div>
    </div>
</template>

<script lang="ts">
import {defineComponent} from "vue";
import {mapActions, mapGetters, mapState} from "vuex";
import FilterSection from "./FilterSection.vue";
import SpinnerGlobal from "@/components/common/SpinnerGlobal.vue";
import ButtonCloseFilter from "@/components/controls/ButtonCloseFilter.vue";
import {store} from "@/store";
import {FilterActionTypes} from "@/store/modules/filter/action-types";

export default defineComponent({
    name: "FilterHolder",
    components: {
        ButtonCloseFilter,
        SpinnerGlobal,
        FilterSection
    },
    setup() {
        function closeFilterModal(): void {
            store.dispatch(FilterActionTypes.SET_IS_OPENED_FILTER_MODAL, false);
        }

        return {
            horizontal: true,
            closeFilterModal,
        }
    },
    props: {
        isLoading: {
            type: Boolean,
            required: true,
        }
    },
    computed: {
        ...mapState(['filter']),
        ...mapGetters({
            filterTitle: 'getFilterTitle',
            cancelLabel: 'getCancelFilterLabel',
            changedSlides: 'getChangedSlides',
            selectedChecks: 'getFilterSelection',
            isOpenedFilterModal: 'getIsOpenedFilterModal',
            closeFilterLabel: 'getCloseFilterLabel',
            applyFilterLabel: 'getApplyFilterLabel',
        }),
        applyOrCloseFilterLabel() {
            return this.isAppliedFilter ? this.applyFilterLabel : this.closeFilterLabel;
        },
        isAppliedFilter() {
            return this.changedSlides.length || this.selectedChecks.length;
        }
    },
    methods: mapActions({
        clearFilter: 'CLEAR_FILTRATION'
    })
});
</script>
